import type {
  CommunicationAudienceSelection,
  CommunicationLinkedSource,
  CommunicationRecipientSnapshot,
} from './audience';
import type { EmailTemplate } from './types';

export type CommunicationRecipientStatus =
  | 'intended'
  | 'suppressed'
  | 'accepted'
  | 'delivered'
  | 'first-opened'
  | 'bounced'
  | 'spam-complaint'
  | 'failed';

export interface CommunicationRollup {
  intended: number;
  accepted: number;
  delivered: number;
  firstOpened: number;
  bounced: number;
  complained: number;
  suppressed: number;
  failed: number;
  attention: number;
}

export interface CommunicationHistoryRecipient {
  id?: string;
  communicationId: string;
  email: string;
  displayName: string;
  greeting?: string;
  status: CommunicationRecipientStatus;
  firstOpenedAt?: string;
  deliveredAt?: string;
  latestIssue?: string;
  hasActiveIssue?: boolean;
  personnelId?: string;
  sourceLabels?: string[];
}

export interface CommunicationHistoryItem {
  id: string;
  templateAlias: EmailTemplate;
  subject: string;
  origin: 'manual' | 'automated' | 'system';
  sentAt: string;
  sentBy?: string;
  rollup: CommunicationRollup;
  audienceSummary?: string;
  audienceSelection?: CommunicationAudienceSelection | null;
  recipientSnapshot?: CommunicationRecipientSnapshot | null;
  linkedSource?: CommunicationLinkedSource | null;
  recipients: CommunicationHistoryRecipient[];
  summaryOnly?: boolean;
}

export const EMPTY_COMMUNICATION_ROLLUP: CommunicationRollup = {
  intended: 0,
  accepted: 0,
  delivered: 0,
  firstOpened: 0,
  bounced: 0,
  complained: 0,
  suppressed: 0,
  failed: 0,
  attention: 0,
};
